import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { RedpackDetail } from './RedpackDetail';
import { RedpackList } from './RedpackList';

export const Redpack = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={RedpackList} />
    <Route path={`${props.match.path}/:id`} component={RedpackDetail} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/redpack/Redpack.tsx